'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './checkout-login-register.component';
import dynamic from 'next/dynamic';

const DynamicCheckoutLoginRegisterComponent: ComponentType<Props> = dynamic(
  () => import('./checkout-login-register.component')
);

export default DynamicCheckoutLoginRegisterComponent;

export function calculateCheckoutLoginRegisterPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 678 },
    { sinceWidth: 525, height: 640 },
    { sinceWidth: 768, height: 639 },
    { sinceWidth: 1024, height: 741 },
    { sinceWidth: 14410, height: 644 }
  ];

  return {
    heightSinceWidth
  };
}
